<template>

    <div class="card" v-if="!loading">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end m-2">
            <router-link
                v-if="canVisitAllWorkSheetList"
                :to="{ name: 'PageAllWorkSheetList', params: { subject: planned_subject.planned_subject_id }}"
                class="btn btn-outline-secondary"
            >
                {{ $t('まとめて見る') }}
            </router-link>
        </div>
        <div class="card-header bg-info text-white fs-3">
            <i class="bi bi-book me-2"></i> {{ planned_subject.subject_name }}
        </div>
        <div class="list-group list-group-flush">
            <template v-if="student_worksheets.length">
                <template v-for="student_worksheet of student_worksheets" :key="student_worksheet">
                    <router-link
                        :to="getWorksheetRoute(student_worksheet)"
                        class="list-group-item d-flex justify-content-between align-items-start position-relative"
                    >
                        <div>
                            <h4>{{ $t(student_worksheet.planned_worksheet.worksheet_name) }}</h4>
                            <div class="small text-muted">
                                <small class="me-1">{{ $t('配られた日') }}</small>
                                <span class="me-3">{{ student_worksheet.handout_date_display }}</span>
                                <small class="me-1">{{ $t('提出した日') }}</small>
                                <span class="me-3">{{ student_worksheet.submit_datetime_display }}</span>
                            </div>
                        </div>
                        <span
                            class="badge rounded-pill"
                            :class="{
                                'bg-success': student_worksheet.submit_status === SubmitStatus.SUBMITTED,
                                'bg-danger': student_worksheet.submit_status === SubmitStatus.PENDING ||
                                student_worksheet.submit_status === SubmitStatus.RESUBMIT,
                                'bg-secondary': student_worksheet.submit_status === SubmitStatus.NONNED
                            }">
                                {{ $t(student_worksheet.submit_status_display) }}
                        </span>
                        <div class="position-absolute end-0 bottom-0 py-1 px-3 border-0 bg-transparent">
                            <template v-if="
                                planned_subject.option_comment !== OptionComment.NONE &&
                                student_worksheet.comment_count > 0
                            ">
                                <i class="bi bi-chat-fill text-success"></i> {{ student_worksheet.comment_count }}
                            </template>
                            <template v-if="
                                planned_subject.option_like !== OptionLikePermission.NONE &&
                                student_worksheet.like_count > 0
                            ">
                                <i class="bi bi-heart-fill text-danger ms-2"></i> {{ student_worksheet.like_count }}
                            </template>
                        </div>
                    </router-link>
                </template>
            </template>
            <div class="list-group-item" v-else>{{ $t('ふり返りシート') }}はありません</div>
        </div>
    </div>
</template>

<script>
import PlannedSubject from '@/shared/models/entities/repocraft/planned-subject';
import StudentWorksheet from '@/shared/models/entities/repocraft/student-worksheet';
import SubmitStatus from '@/shared/models/enums/submit-status';
import OptionComment from '@/shared/models/enums/option-comment';
import OptionLikePermission from '@/shared/models/enums/option-like-permission';

export default {
    name: 'PageWorkList',
    components: {

    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            loading: true,

            //児童ふり返りシート一覧
            student_worksheets: [],

            //題材名
            planned_subject: new PlannedSubject(),

            //enums
            SubmitStatus: SubmitStatus,
            OptionComment: OptionComment,
            OptionLikePermission: OptionLikePermission,
        }
    },
    mounted() {
        this.startScreenLoading();

        this.$http.get(`/repocraft/subject/${parseInt(this.$route.params.subject, 10)}`)
        .then(response => {
            this.planned_subject = new PlannedSubject(response.data);

            //児童ふり返りシートｓ取得
            this.getStudentWorksheets();
        })
        .finally(() => {
            this.endScreenLoading();
        });
    },
    computed: {
        // 一題材ごとのふり返りシートをまとめて見るページにいけるかどうか
        canVisitAllWorkSheetList() {
            if (!this.student_worksheets.length) {
                return false;
            }

            let unsubmit_student_worksheets = this.student_worksheets.filter(student_worksheet => {
                return (
                    student_worksheet.submit_status === SubmitStatus.PENDING
                    || student_worksheet.submit_status === SubmitStatus.RESUBMIT
                )
            });

            if (unsubmit_student_worksheets.length === this.student_worksheets.length) {
                return false;
            }

            return true;
        }
    },
    methods: {
        //児童worksheets取得
        getStudentWorksheets() {
            this.loading = true;
            this.startScreenLoading();
            this.$http.get(`/repocraft/subject/${parseInt(this.$route.params.subject, 10)}/worksheet`)
            .then(response => {
                for (let row of response.data) {
                    this.student_worksheets.push(new StudentWorksheet(row));
                }
            })
            .finally(() => {
                this.loading = false;
                this.endScreenLoading();
            });
        },

        //未提出・再提出だとPageWorkSubmit,提出済・提出不要だとPageWorkViewへのルートを返す
        getWorksheetRoute(student_worksheet) {
            if (
                student_worksheet.submit_status === SubmitStatus.PENDING ||
                student_worksheet.submit_status === SubmitStatus.RESUBMIT
            ) {
                return {
                    name: 'PageWorkSubmit',
                    params: {
                        subject: parseInt(this.$route.params.subject, 10),
                        worksheet: student_worksheet.student_worksheet_id
                    }
                }

            } else {
                return {
                    name: 'PageWorkView',
                    params: {
                        subject: parseInt(this.$route.params.subject, 10),
                        worksheet: student_worksheet.student_worksheet_id
                    }
                }
            }
        },
        // viewComments() {
        //     this.$router.push({name: 'PageGalleryCommentToMe', params: { subject: parseInt(this.$route.params.subject, 10) }});
        // }
    }
}
</script>

<style scoped>

</style>
